<template>
  <a-card :style="{ height: '900px', userSelect: 'none' }" :bordered="false">
    <div class="user-info">
      <a-icon :style="{ fontSize: '20px', marginRight: '8px' }" type="user" />
      <span>所有人：{{ userName }}  |  车辆品牌：{{ carBrand }}</span>
    </div>

    <a-row :gutter="[16, 16]">
      <!-- 步骤指示器 -->
      <div class="arrow-container">
        <div
          v-for="(arrow, index) in arrows"
          :key="index"
          class="arrow"
        >
          <span class="arrow-title" :style="currentIndex === index ? 'color: white;' : ''">
            {{ arrow }}
          </span>
          <div class="rectangle" :style="currentIndex === index ? 'background-color: rgb(25 84 217);' : ''"></div>
          <div v-if="index !== 2" class="triangle-out" :style="currentIndex === index ? 'border-left:20px solid rgb(25 84 217);' : ''"></div>
          <div v-if="index !== 0" class="triangle-in" :style="currentIndex === index ? 'background-color: rgb(25 84 217);' : ''"></div>
        </div>
      </div>

      <!-- 阶段一：阅读选号须知 -->
      <div v-if="currentIndex === 0">
        <a-row class="desc">
          <span>
            一、系统将提供
            <span :style="{ fontSize: '26px', fontWeight: '600', color: 'red' }">"50"选1</span>
            的选号方式，"50"个号牌号码在显示屏上分多屏显示；
          </span>
          <span>
            二、进入选号阶段时，请先点击
            <span :style="{ fontSize: '26px', fontWeight: '600', color: 'red' }">"开始选号"</span>
            按钮，并在
            <span :style="{ fontSize: '26px', fontWeight: '600', color: 'red' }">"180"秒</span>
            内完成选号；
          </span>
          <div class="desc" :style="{ backgroundColor: 'yellow' }">
            <span>
              三、未在规定时间内完成选号的，将按照以下方法确定机动车号牌；
            </span>
            <span>
              1) 您未选取任何一个号牌号码，系统自动确定号牌列表的第一个为最终选定号牌号码；
            </span>
            <span>
              2) 您选取了其中一个号牌号码，但未进行确认的,系统以您选取的结果为最终选定的号牌号码；
            </span>
          </div>
        </a-row>
        <div class="footer-buttons">
          <a-button type="danger" ghost @click="handleExit">退出系统</a-button>
          <a-button :style="{ backgroundColor: '#24b43c', color: '#ffffff', width: '200px', marginLeft: '10px' }" type="success" @click="handleNext(1)">
            我已阅读，开始选号
          </a-button>
        </div>
      </div>

      <!-- 阶段二：选择号牌 -->
      <div v-if="currentIndex === 1">
        <!-- 确认状态 -->
        <div v-if="showConfirm">
          <a-row :style="{ borderBottom: '1px solid rgb(218, 218, 218)', borderTop: '1px solid rgb(218, 218, 218)', fontSize: '18px', textAlign: 'center' }" :gutter="[16, 16]">
            <span>请在</span>
            <span :style="{ color: 'rgb(223, 86, 86)', fontSize: '28px' }">{{ time }}</span>
            <span>秒内完成选号，您可以翻页查看并点选心仪的号牌。</span>
          </a-row>
          <a-row class="desc">
            <div class="footer-buttons" :style="{ backgroundColor: 'rgb(255 255 185)', width: '500px', height: '150px', alignItems: 'center', gap: '0' }">
              <span :style="{ fontSize: '32px', fontWeight: '540' }">您当前选择号码：</span>
              <span :style="{ color: 'rgb(223 34 34)', fontSize: '28px', fontWeight: '700' }">{{ selectedPlates }}</span>
            </div>
          </a-row>
          <div class="footer-buttons">
            <a-button type="danger" ghost @click="returnSelect">返回重选</a-button>
            <a-button :style="{ backgroundColor: '#24b43c', border: '0' }" type="primary" @click="handleNext(2)">确认号码</a-button>
          </div>
        </div>
        <!-- 选择状态 -->
        <div v-else>
          <a-row :style="{ fontSize: '18px', textAlign: 'center', paddingBottom: '10px' }" :gutter="[16, 16]">
            <span>请在</span>
            <span :style="{ color: 'rgb(223, 86, 86)', fontSize: '28px' }">{{ time }}</span>
            <span>秒内点击</span>
            <span :style="{ color: 'rgb(223, 86, 86)' }">{{ isRunning ? '开始选号' : '确认号牌' }}</span>
            <span>，共50个号牌号码供您选择，您可查看并点选心仪的号牌。</span>
          </a-row>
          <a-row :style="{ borderBottom: '1px solid rgb(218, 218, 218)', borderTop: '1px solid rgb(218, 218, 218)' }" :gutter="[16, 16]">
            <a-col :span="4"></a-col>
            <a-col :span="6" :style="{ padding: '2px 0' }">
              <a-button
                v-if="isRunning"
                :style="{ backgroundColor: '#1d70ed', color: '#ffffff', border: '0', height: '45px', width: '220px', fontSize: '20px', fontWeight: '600' }"
                type="primary"
                @click="stopRandom"
              >
                开始选号
              </a-button>
              <a-button
                v-else
                :style="{ backgroundColor: '#24b43c', color: '#ffffff', border: '0', height: '45px', width: '220px', fontSize: '20px', fontWeight: '600' }"
                type="primary"
                @click="confirmSelect"
              >
                确认号牌
              </a-button>
            </a-col>
            <a-col v-if="!isRunning" :span="5" :style="{ backgroundColor: 'rgb(255 255 185)', display: 'flex', justifyContent: 'center', padding: '4px 0 0 0', marginTop: '2px' }">
              <span :style="{ fontSize: '25px', fontWeight: '700' }">当前选择号码：</span>
              <span :style="{ color: 'rgb(223 34 34)', fontSize: '28px', fontWeight: '700' }">{{ selectedPlates }}</span>
            </a-col>
          </a-row>
          <a-row :style="{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }" :gutter="[16, 16]">
            <a-col v-for="(plate, index) in plates" :key="index" :span="4" :style="{ padding: '10px 30px' }">
              <a-card
                class="plate-card"
                :bordered="false"
                :body-style="{ padding: '0' }"
                @click="select(plate)"
              >
                <a-icon v-if="selectedPlates === plate" class="duihao" type="check" />
                <div class="plate-css" :style="selectedPlates === plate ? 'color: rgb(223 34 34);' : ''">
                  {{ plate }}
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 阶段三：完成选号 -->
      <div v-if="currentIndex === 2">
        <a-row :style="{ borderBottom: '1px solid rgb(218, 218, 218)', borderTop: '1px solid rgb(218, 218, 218)', textAlign: 'center' }">
          <span :style="{ fontSize: '20px', height: '20px' }">恭喜您，已成功完成选号！</span>
        </a-row>
        <a-row class="desc">
          <div :style="{ gap: '30px', padding: '30px', display: 'grid', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f1f1f1', borderRadius: '5px' }">
            <span :style="{ fontSize: '26px', fontWeight: '600' }">您的爱车号牌号码为：</span>
            <span :style="{ fontSize: '40px', fontWeight: '600', color: 'rgb(2, 33, 68)' }">{{ selectedPlates }}</span>
          </div>
        </a-row>
        <div class="footer-buttons">
          <a-button :style="{ backgroundColor: '#24b43c', color: '#ffffff', width: '200px', marginLeft: '10px' }" type="success" @click="handleNext(3)">
            完成选号
          </a-button>
        </div>
      </div>
    </a-row>
  </a-card>
</template>

<script>
const FAMILY_NAMES = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄']
const GIVEN_NAMES = ['伟', '芳', '娜', '秀英', '敏', '静', '丽', '强', '磊', '军', '洋', '勇', '艳', '杰', '娟', '涛', '明', '超', '秀兰', '霞', '平', '刚', '桂英', '文', '辉', '建华', '玲', '红', '晶', '华', '玉兰', '桂兰', '建国', '建军', '建平', '建华', '国强', '国庆', '子豪', '思琪', '雨婷', '佳怡', '宇轩', '浩然', '梓萱', '梓涵', '梓豪', '雨航', '雨翔', '思莹', '浩轩', '浩然', '丽娜', '晓明', '志强', '冬梅', '俊杰', '婷婷', '静怡', '浩然', '欣欣', '云飞', '天宇', '雨欣', '梓涵', '梓轩', '宇航', '子轩', '梓萱', '欣怡', '煜婷', '煜祺', '俊杰', '博文', '志豪', '嘉欣', '思远', '梓豪', '欣悦', '俊杰', '梓轩', '晨曦', '欣妍', '浩宇', '智轩', '俊驰', '雨辰', '彤彤', '煜城', '昊然', '志泽', '俊楠']
const CAR_BRANDS = ['比亚迪', '吉利', '长安', '小米', '威马', '理想', '蔚来', '极氪', '哪吒', '广汽', '奇瑞', '红旗', '坦克', '问界', '飞凡', '智己', '高合', '岚图', '零跑', '欧拉', '魏牌', '凯迪拉克', '东风', '五菱', '丰田', '本田', '大众', '别克', '奥迪', '宝马', '奔驰', '雷克萨斯', '英菲尼迪', '沃尔沃', '路虎', '保时捷']
const CAR_PREFIXES = ['BYD', 'GLY', 'CAN', 'XMC', 'WMA', 'LXQ', 'NIO', 'ZKR', 'NZT', 'GAC', 'QRY', 'HQI', 'TNK', 'WJE', 'FFN', 'ZHJ', 'GAH', 'LTU', 'LPS', 'ORA', 'WEY', 'CTL', 'DFM', 'WLG', 'GTM', 'HRV', 'VLK', 'GLX', 'AUD', 'BMW', 'BNZ', 'LXS', 'IFN', 'VLV', 'LRV', 'PSC']

export default {
  name: 'SelectedNum',
  data () {
    return {
      userName: '',
      carBrand: '',
      plates: [],
      isRunning: false,
      intervalId: null,
      selectedPlates: null,
      arrows: ['阶段一：阅读选号须知', '阶段二：选择号牌', '阶段三：完成选号'],
      time: 180,
      timer: null,
      currentIndex: 0,
      maxSpecialPlates: 3,
      generatedSpecialPlates: new Set(),
      isShowProvince: false,
      selectedProvince: '豫',
      selectedArea: 'A',
      showConfirm: false
    }
  },
  mounted () {
    this.generateRandomInfo()
  },
  methods: {
    select (plate) {
      if (!this.isRunning) {
        this.selectedPlates = plate
      }
    },
    handleNext (step) {
      if (step === 3) {
        this.$router.push({ path: '/' })
      } else if (step === 2) {
        if (this.selectedPlates) {
          this.$store.state.recordPlates.push(this.selectedPlates)
        }
      } else if (step === 1) {
        this.plates = []
        this.startRandom()
      }
      this.currentIndex = step
    },
    confirmSelect () {
      this.showConfirm = true
    },
    returnSelect () {
      this.showConfirm = false
    },
    generatePlate () {
      const digits = '0123456789'
      const areaSettings = this.$store.state.areaSettings
      const random = Math.random() * 100
      let selectedArea = areaSettings.areas[0]

      const totalProbability = areaSettings.areas.reduce((sum, area) => {
        return sum + (areaSettings.areaProbabilities[area] || 20)
      }, 0)

      if (random <= totalProbability) {
        let cumulative = 0
        for (const area of areaSettings.areas) {
          cumulative += areaSettings.areaProbabilities[area] || 20
          if (random <= cumulative) {
            selectedArea = area
            break
          }
        }
      }

      const letterRules = this.$store.state.letterRules
      const ruleRandom = Math.random() * 100
      let cumulative = 0
      let selectedRule = null

      for (const rule of letterRules) {
        cumulative += rule.probability
        if (ruleRandom <= cumulative) {
          selectedRule = rule
          break
        }
      }

      let plateNumber = ''
      const isNewEnergy = selectedRule && selectedRule.type === 'new'
      const positions = selectedRule ? selectedRule.positions : []
      const plateLength = isNewEnergy ? 6 : 5

      if (selectedRule) {
        for (let i = 0; i < plateLength; i++) {
          if (positions[i]) {
            plateNumber += positions[i]
          } else {
            plateNumber += digits[Math.floor(Math.random() * digits.length)]
          }
        }
      } else {
        for (let i = 0; i < plateLength; i++) {
          plateNumber += digits[Math.floor(Math.random() * digits.length)]
        }
      }

      return `${selectedArea}${plateNumber}`
    },
    generateSpecialPlate () {
      const digits = '0123456789'
      let attempts = 0
      const maxAttempts = 10

      const generate = () => {
        const areaSettings = this.$store.state.areaSettings
        const random = Math.random() * 100
        let selectedArea = this.$store.state.selectedArea

        const totalProbability = areaSettings.areas.reduce((sum, area) => {
          return sum + (areaSettings.areaProbabilities[area] || 20)
        }, 0)

        if (random <= totalProbability) {
          let cumulative = 0
          for (const area of areaSettings.areas) {
            cumulative += areaSettings.areaProbabilities[area] || 20
            if (random <= cumulative) {
              selectedArea = area
              break
            }
          }
        }

        const letterRules = this.$store.state.letterRules
        const ruleRandom = Math.random() * 100
        let cumulative = 0
        let selectedRule = {}

        if (letterRules.length === 1) {
          selectedRule = letterRules[0]
        } else if (letterRules.length === 0) {
          selectedRule.positions = ['', '', '', '', '']
        } else {
          for (const rule of letterRules) {
            cumulative += rule.probability
            if (ruleRandom <= cumulative) {
              selectedRule = rule
              break
            }
          }
        }

        let plateNumber = ''
        const pattern = Math.floor(Math.random() * 3)
        const isNewEnergy = selectedRule && selectedRule.type === 'new'
        const positions = selectedRule ? selectedRule.positions : []
        const plateLength = isNewEnergy ? 6 : 5

        switch (pattern) {
          case 0: {
            const sameDigit = digits[Math.floor(Math.random() * digits.length)]
            for (let i = 0; i < plateLength; i++) {
              if (positions[i]) {
                plateNumber += positions[i]
              } else {
                plateNumber += sameDigit
              }
            }
            break
          }
          case 1: {
            const direction = Math.random() > 0.5 ? 1 : -1
            let start = direction === 1
              ? Math.floor(Math.random() * (10 - plateLength))
              : Math.floor(Math.random() * plateLength) + (10 - plateLength)
            let current = start
            for (let i = 0; i < plateLength; i++) {
              if (positions[i]) {
                plateNumber += positions[i]
              } else {
                plateNumber += digits[current]
                current += direction
              }
            }
            break
          }
          case 2:
            for (let i = 0; i < plateLength; i++) {
              if (positions[i]) {
                plateNumber += positions[i]
              } else {
                plateNumber += i < plateLength - 1 ? '0' : digits[Math.floor(Math.random() * digits.length)]
              }
            }
            break
        }

        return `${selectedArea}${plateNumber}`
      }

      let plate
      do {
        plate = generate()
        attempts++
      } while (this.generatedSpecialPlates.has(plate) && attempts < maxAttempts)

      if (attempts >= maxAttempts) {
        this.generatedSpecialPlates.clear()
      }

      this.generatedSpecialPlates.add(plate)
      return plate
    },
    generatePlates () {
      const plates = []
      const specialIndices = []

      while (specialIndices.length < this.$store.state.specialNum) {
        const index = Math.floor(Math.random() * 50)
        if (!specialIndices.includes(index)) {
          specialIndices.push(index)
        }
      }

      for (let i = 0; i < 50; i++) {
        if (specialIndices.includes(i)) {
          plates.push(this.generateSpecialPlate())
        } else {
          plates.push(this.generatePlate())
        }
      }

      return plates
    },
    startRandom () {
      if (this.$store.state.selectedProvince && this.$store.state.selectedArea) {
        this.isRunning = true
        this.intervalId = setInterval(() => {
          this.plates = this.generatePlates()
        }, 50)
        this.resetTimer()
      } else {
        this.$message.warning('请先选择省份！')
      }
    },
    stopRandom () {
      clearInterval(this.intervalId)
      this.isRunning = false
      this.selectedPlates = this.plates[0]

      let recordPlates = this.$store.state.recordPlates
      let hasDuplicate = recordPlates.some(plate => this.plates.includes(plate))

      while (hasDuplicate) {
        this.plates = this.generatePlates()
        hasDuplicate = recordPlates.some(plate => this.plates.includes(plate))
      }

      this.plates = Array.from(new Set(this.plates))

      while (this.plates.length < 50) {
        const newPlate = this.generatePlate()
        const isDuplicate = recordPlates.some(plate => plate === newPlate)
        if (!isDuplicate) {
          this.plates.push(newPlate)
        }
        this.plates = Array.from(new Set(this.plates))
      }

      if (this.$store.state.fixedPlate) {
        const randomIndex = Math.floor(Math.random() * 50)
        this.plates.splice(randomIndex, 1, this.$store.state.fixedPlate)
      }
    },
    startTimer () {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
        } else {
          this.currentIndex = 2
          this.stopTimer()
        }
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    resetTimer () {
      this.stopTimer()
      this.time = 180
      this.startTimer()
    },
    generateRandomInfo () {
      if (this.$store.state.userName) {
        this.userName = this.$store.state.userName
      } else {
        const familyName = FAMILY_NAMES[Math.floor(Math.random() * FAMILY_NAMES.length)]
        const givenName = GIVEN_NAMES[Math.floor(Math.random() * GIVEN_NAMES.length)]
        this.userName = familyName + givenName
      }

      let brandName, brandPrefix
      if (this.$store.state.carBrand) {
        brandName = this.$store.state.carBrand
        const brandIndex = CAR_BRANDS.indexOf(brandName)
        if (brandIndex > -1) {
          brandPrefix = CAR_PREFIXES[brandIndex]
        }
      } else {
        const randomIndex = Math.floor(Math.random() * CAR_BRANDS.length)
        brandName = CAR_BRANDS[randomIndex]
        brandPrefix = CAR_PREFIXES[randomIndex]
      }

      const randomNumber = Math.floor(Math.random() * 9000) + 1000
      const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
      const letter1 = letters[Math.floor(Math.random() * letters.length)]
      const letter2 = letters[Math.floor(Math.random() * letters.length)]

      this.carBrand = `${brandName}牌${brandPrefix}${randomNumber}${letter1}${letter2}`
    },
    handleExit () {
      this.$confirm({
        title: '确认退出',
        content: '确定要退出系统吗？',
        onOk: () => {
          // 停止定时器
          if (this.timer) {
            this.stopTimer()
          }
          if (this.intervalId) {
            clearInterval(this.intervalId)
          }
          // 清除登录状态
          this.$store.commit('setIsLoggedIn', false)
          this.$store.commit('setCurrentUser', null)
          // 跳转到登录页
          this.$router.push('/login')
        }
      })
    }
  }
}
</script>

<style scoped>
.plate-card {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 5px;
  position: relative;
}

.ant-card-body {
  padding: 0;
  zoom: 1;
}

.arrow-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.arrow {
  position: relative;
  width: 375px;
  height: 40px;
}

.rectangle {
  width: 350px;
  height: 40px;
  background-color: #8cbbe7;
  position: absolute;
  left: 10px;
}

.triangle-out {
  border-left: 20px solid #8cbbe7;
  left: 360px;
}

.triangle-in,
.triangle-out {
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  position: absolute;
}

.triangle-in {
  border-right: 20px solid #fff;
  left: 10px;
  transform: scaleX(-1);
}

.desc {
  display: grid;
  justify-content: center;
  justify-items: start;
  gap: 20px;
  font-size: 17px;
}

.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 100px;
  margin-top: 80px;
}

.plate-css {
  color: #444;
  font-size: 28px;
  display: block;
}

.duihao {
  color: #df2222;
  position: absolute;
  margin-top: 7px;
  left: 10px;
  font-size: 28px;
  font-weight: 900;
}

.arrow-title {
  z-index: 1000;
  position: absolute;
  left: 110px;
  top: 7px;
  color: #5d83c9;
  font-size: large;
}

.user-info {
  position: fixed;
  left: 10px;
  bottom: 10px;
  background-color: transparent;
  padding: 10px 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
</style>

